<div class="container">

  <form class="post-message-form" [formGroup]="engagementFormGroup">
    <div class="box-wrapper">
      <div class="title">המסר</div>
      <div class="header">
        <mat-icon>camera_alt</mat-icon>
        <span>תמונה</span>
        <mat-slide-toggle class="toggle" id="img-toggle" [disabled]="isVideo"
        (change)="changeToggleState($event)"></mat-slide-toggle>
      </div>
      @if (isImage) {
        <file-load formControlName="imageFile" [fileTypes]="'image/png, image/jpeg'"></file-load>
      }
      <div class="header">
        <mat-icon>videocam</mat-icon>
        <span>וידאו</span>
        <mat-slide-toggle class="toggle" id="vid-toggle" [disabled]="isImage"
        (change)="changeToggleState($event)"></mat-slide-toggle>
      </div>
      @if (isVideo) {
        <file-load formControlName="videoFile" [fileTypes]="'video/mp4'"></file-load>
      }
      <div class="header">
        <mat-icon>title</mat-icon>
        <span>טקסט</span>
        <mat-slide-toggle class="toggle" id="text-toggle" (change)="changeToggleState($event)"></mat-slide-toggle>
      </div>
      @if (isText) {
        <text-form formControlName="text"></text-form>
      }
    </div>

    @if (applicationItem()?.id !== ApplicationEnum.tiktok) {
    <div class="box-wrapper">

      <span class="title">היעד</span>

      @if (applicationItem()?.id === ApplicationEnum.telegram || applicationItem()?.id === ApplicationEnum.telegramBt) {
        <div class="flex-container">
          <anchor-type [anchorTypeList]="anchorsTypeList" (onSelectedAnchorType)="anchorTypeChanged($event)"></anchor-type>

          @if (applicationItem()?.id === ApplicationEnum.telegram) {
            <div class="alert-container">
              <mat-icon class="notice-icon">priority_high</mat-icon>

              <span class="truncated-text">מגבלת אווטארים (לחץ להצגה)</span>

              <button mat-icon-button [matMenuTriggerFor]="infoMenu" class="toggle-btn">
                <mat-icon class="triangle-icon">arrow_drop_down</mat-icon>
              </button>

              <mat-menu #infoMenu="matMenu" class="alert-menu">
                <div class="full-text-padding" (click)="$event.stopPropagation()">
                  <p>מספר אווטארים זמינים: {{numOfAvailableTgAvatars()}}</p>
                  <p>{{alert2()}}</p>
                  <p>{{alert3()}}</p>
                </div>
              </mat-menu>
            </div>
          }
        </div>
      }

      @if (applicationItem()?.id === ApplicationEnum.facebook || (applicationItem()?.id === ApplicationEnum.telegramBt && isGroups)) {

        <div class="group-urls-section" dir="rtl">
          <div class="button-row">
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="add-input compact-form">
              <mat-label>הוסף קישור לקבוצה/דף...</mat-label>
              <input matInput [ngModel]="newGroupUrl()" (ngModelChange)="newGroupUrl.set($event)" [ngModelOptions]="{standalone: true}" (keyup.enter)="addGroupUrl()">
            </mat-form-field>

            <button mat-icon-button color="primary" (click)="addGroupUrl()" [disabled]="!newGroupUrl().trim()" matTooltip="הוסף קישור">
              <mat-icon>add</mat-icon>
            </button>

            <div class="divider"></div>

            <button mat-icon-button color="primary" (click)="openSelectGroupDialog($event)" matTooltip="בחר קבוצה">
              <mat-icon>search</mat-icon>
            </button>

            @if (engagementFormGroup.get('groupUrls')?.value?.length > 0) {
              <button mat-icon-button color="accent"
                [disabled]="!groupList() || !groupList()!.selectedOptions.selected.length"
                (click)="deleteSelected()" matTooltip="מחק בחירה">
                <mat-icon>delete</mat-icon>
              </button>

              <button mat-icon-button color="accent" (click)="clearList()" matTooltip="נקה רשימה">
                <mat-icon>delete_sweep</mat-icon>
              </button>
            }
          </div>

          <div class="scroll-container">
            <mat-selection-list #urlList [multiple]="false">
              @for (item of engagementFormGroup.get('groupUrls')?.value; track $index) {
                <mat-list-option [value]="item" [matTooltip]="item" togglePosition="before" (dblclick)="editItem($index)" (click)="onOptionClick($event, $index)">
                  @if (editingIndex() === $index) {
                    <input matInput [ngModel]="editingText()" (ngModelChange)="editingText.set($event)" [ngModelOptions]="{standalone: true}"
                      (keyup.enter)="saveEdit($index)" (keyup.escape)="cancelEdit()"
                      (blur)="saveEdit($index)" class="inline-edit-input">
                  } @else {
                    {{ item }}
                  }
                </mat-list-option>
              } @empty {
                <div class="empty-state">
                  <mat-icon>info</mat-icon>
                  <p>לא נבחרו קבוצות</p>
                </div>
              }
            </mat-selection-list>
          </div>

          @if (urlValidationError()) {
            <mat-error class="url-error">{{ urlValidationError() }}</mat-error>
          }

          @if (engagementFormGroup.get('groupUrls')?.hasError('requiredGroupUrlsViolation') && engagementFormGroup.get('groupUrls')?.touched) {
            <mat-error class="url-error">
              חובה לבחור לפחות קבוצה אחת
            </mat-error>
          }
        </div>

      }

      @if (selectedAnchorType && (applicationItem()?.id === ApplicationEnum.telegram || (applicationItem()?.id === ApplicationEnum.telegramBt && isNumbers))) {
        <multi-input formControlName="anchors" [anchorType]="selectedAnchorType"></multi-input>
      }

      @if (engagementFormGroup.hasError('zeroAnchorsViolation') && engagementFormGroup.touched) {
        <div class="error-text">
          חובה לבחור עוגן
        </div>
      }
      @if (engagementFormGroup.hasError('fbAnchorCountViolation') && engagementFormGroup.touched) {
        <div class="error-text">
          בפעילות מסוג זה מותר לבחור עוגן אחד בלבד
        </div>
      }
      @if (engagementFormGroup.hasError('tgAvatarsLimitViolation') && engagementFormGroup.touched) {
        <div class="error-text">
          מספר העוגנים חורג ממגבלת אווטארים זמינים
        </div>
      }
      @if (engagementFormGroup.hasError('tgMediaLimitViolation') && engagementFormGroup.touched) {
        <div class="error-text">
          חריגה ממספר העוגנים האפשרי עבור סוג מדיה זה
        </div>
      }

    </div>
    }

  </form>
</div>
